export const userTypes = {
  USERS_SET_USER_INFOS: 'USERS_SET_USER_INFOS',
  UP_USERS_REGISTER: 'UP_USERS_REGISTER',

  USERS_REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  USERS_REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  USERS_REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  USERS_LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  USERS_LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  USERS_LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  UP_USERS_LOGIN: 'UP_USERS_LOGIN',

  USERS_LOG_OUT: 'USERS_LOG_OUT',
  UP_USERS_LOG_OUT: 'UP_USERS_LOG_OUT',

  USERS_VERIFY_TOKEN_FAILURE: 'USERS_VERIFY_TOKEN_FAILURE',
  UP_USERS_VERIFY_TOKEN: 'UP_USERS_VERIFY_TOKEN',

  USERS_GETALL_REQUEST: 'USERS_GETALL_REQUEST',
  USERS_GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
  USERS_GETALL_FAILURE: 'USERS_GETALL_FAILURE',

  USERS_UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
  USERS_UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
  USERS_UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',
  UP_USERS_UPDATE: 'UP_USERS_UPDATE',

  USERS_UPDATE_PASSWORD_REQUEST: 'USERS_UPDATE_PASSWORD_REQUEST',
  USERS_UPDATE_PASSWORD_SUCCESS: 'USERS_UPDATE_PASSWORD_SUCCESS',
  USERS_UPDATE_PASSWORD_FAILURE: 'USERS_UPDATE_PASSWORD_FAILURE',
  UP_USERS_UPDATE_PASSWORD: 'UP_USERS_UPDATE_PASSWORD',

  USERS_RETRIEVE_PASSWORD_REQUEST: 'USERS_RETRIEVE_PASSWORD_REQUEST',
  USERS_RETRIEVE_PASSWORD_EMAIL_SENT: 'USERS_RETRIEVE_PASSWORD_EMAIL_SENT',
  USERS_RETRIEVE_PASSWORD_SUCCESS: 'USERS_RETRIEVE_PASSWORD_SUCCESS',
  USERS_RETRIEVE_PASSWORD_FAILURE: 'USERS_RETRIEVE_PASSWORD_FAILURE',
  UP_USERS_RETRIEVE_PASSWORD: 'UP_USERS_RETRIEVE_PASSWORD',

  USERS_VERIFY_RESET_TOKEN_REQUEST: 'USERS_VERIFY_RESET_TOKEN_REQUEST',
  USERS_VERIFY_RESET_TOKEN_SUCCESS: 'USERS_VERIFY_RESET_TOKEN_SUCCESS',
  USERS_VERIFY_RESET_TOKEN_FAILURE: 'USERS_VERIFY_RESET_TOKEN_FAILURE',
  UP_USERS_VERIFY_RESET_TOKEN: 'UP_USERS_VERIFY_RESET_TOKEN',

  USERS_SET_NEW_PASSWORD_REQUEST: 'USERS_SET_NEW_PASSWORD_REQUEST',
  USERS_SET_NEW_PASSWORD_SUCCESS: 'USERS_SET_NEW_PASSWORD_SUCCESS',
  USERS_SET_NEW_PASSWORDN_FAILURE: 'USERS_SET_NEW_PASSWORD_FAILURE',
  UP_USERS_SET_NEW_PASSWORD: 'UP_USERS_SET_NEW_PASSWORD',

  USERS_DELETE_REQUEST: 'USERS_DELETE_REQUEST',
  USERS_DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  USERS_DELETE_FAILURE: 'USERS_DELETE_FAILURE',

  DOWN_USERS_USERNAME_UPDATE: 'DOWN_USERS_USERNAME_UPDATE',   
  DOWN_USERS_UPDATE_PLAYER_NUMBERS: 'DOWN_USERS_UPDATE_PLAYER_NUMBERS',   

  USERS_UPDATE_USER_PROFILE: 'USERS_UPDATE_USER_PROFILE'
};